import React, { useRef } from "react";
import { useCreateMarker, useInitializeMap } from "./hooks";

const Map = ({ coordiantes, editMode, element }: any) => {
  const mapContainer = useRef<any>(null);

  // initializing the map
  const { map, isMapFullyLoaded } = useInitializeMap(
    mapContainer,
    editMode,
    element
  );

  // showing the long lat by creating the marker
  useCreateMarker(map, isMapFullyLoaded, coordiantes, element);

  return <div ref={mapContainer} className="h-[400px] w-full"></div>;
};

export default Map;
